import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from '../pages/Login';
import Page404 from '../pages/Page404';
import PrivateRoute from './PrivateRoute';
import Products from '../pages/Products';
// import NewProduct from '../pages/NewProduct';
import ProdQuery from '../pages/ProdQuery';
import Movements from '../pages/Movements';
import MovementIn from '../pages/MovementIn';
import MovementOut from '../pages/MovementOut';
import SearchStock from '../pages/SearchStock';
import Main from '../pages/Main';
import Movement from '../pages/Movement';
import MovementEdit from '../pages/MovementEdit';
import MovementReceipt from '../pages/MovementReceipt';
import TransferOrderList from '../pages/Inventory/Transfers/TransferOrderList';
import TransferOrderNew from '../pages/Inventory/Transfers/TransferOrderNew';
import TransferOrderShow from '../pages/Inventory/Transfers/TransferOrderShow';
import TransferOrderEdit from '../pages/Inventory/Transfers/TransferOrderEdit';
import TransferShipmentList from '../pages/Inventory/Transfers/TransferShipmentList';
import StockPosition from '../pages/Inventory/StockPosition';
import ProductEdit from '../pages/ProductEdit';
import Categories from '../pages/Categories';
import NewProdCategory from '../pages/NewProdCategory';
import Brands from '../pages/Brands';
import AdvancedProductSearch from '../pages/AdvancedProductSearch';
import Page403 from '../pages/Page403';
import CreateUser from '../pages/CreateUser';
import UiShowcasePage from '../pages/UiShowCasePage/UiShowCasePage';
import VolumetryCalculator from '../pages/VolumetryCalculator';
import XmlImportDemo from '../pages/MovementInByXml';
import EditUser from '../pages/EditUser';
import ListUsers from '../pages/ListUsers';
import ExperimentalDashboard from '../pages/_test/ExperimentalDashboard';
import ServiceOrderList from '../pages/_test/ServiceOrderList';
import ServiceOrderDashboard from '../pages/_test/ServiceOrderDashboard';
import ServiceOrderShow from '../pages/_test/ServiceOrderShow';
import ActiveCRMPrototype from '../pages/_test/ActiveCRMPrototype';
import StockHistoryByDate from '../pages/StockHistoryByDate';
import StockComparison from '../pages/StockComparison';
import StockEvolution from '../pages/StockEvolution';
import StockLowStockProducts from '../pages/StockLowStockProducts';
import StockPdvSnapshot from '../pages/StockPdvSnapshot';
import Roles from '../pages/Roles';
import RoleShow from '../pages/RoleShow';
import Permissions from '../pages/Permissions';
import PermissionShow from '../pages/PermissionShow';
import BillingCharges from '../pages/BillingCharges';
import BillingCharge from '../pages/BillingCharge';
import BillingGroupShow from '../pages/BillingGroupShow';
import CreditSalesDashboard from '../pages/Finance/CreditSalesDashboard';
import EmployeeForm from '../pages/hr/EmployeeForm';
import EmployeeList from '../pages/hr/EmployeeList';
import EmployeeShow from '../pages/hr/EmployeeShow';
import EmployeeDebtsReport from '../pages/hr/EmployeeDebtsReport';
import CandidatePoolList from '../pages/hr/Recruitment/CandidatePoolList';
import CandidateForm from '../pages/hr/Recruitment/CandidateForm';
import CandidateShow from '../pages/hr/Recruitment/CandidateShow';
import OpeningList from '../pages/hr/Recruitment/OpeningList';
import OpeningForm from '../pages/hr/Recruitment/OpeningForm';
import OpeningShow from '../pages/hr/Recruitment/OpeningShow';
import OriginsCatalog from '../pages/hr/Recruitment/OriginsCatalog';
import OnboardingShow from '../pages/hr/Recruitment/OnboardingShow';
import PositionRequirementsCatalog from '../pages/hr/Recruitment/PositionRequirementsCatalog';
import ServiceAquisitionList from '../pages/ServiceAquisition/ServiceAquisitionList';
import ServiceAquisitionShow from '../pages/ServiceAquisition/ServiceAquisitionShow';
import ServiceAquisitionForm from '../pages/ServiceAquisition/ServiceAquisitionForm';
import ServiceAquisitionProviderList from '../pages/ServiceAquisition/ServiceAquisitionProviderList';
import RoutingItemList from '../pages/Routing/RoutingItemList';
import RoutingItemShow from '../pages/Routing/RoutingItemShow';
import RoutingItemNew from '../pages/Routing/RoutingItemNew';
import RouteManagement from '../pages/Routing/RouteManagement';
import RoutingScheduleList from '../pages/Routing/RoutingScheduleList';
import ProductivityReport from '../pages/Routing/ProductivityReport';
import ServiceCatalog from '../pages/Routing/ServiceCatalog';
import ClienteList from '../pages/Comercial/ClienteList';
import ClienteForm from '../pages/Comercial/ClienteForm';
import ClienteShow from '../pages/Comercial/ClienteShow';
import BankAccountList from '../pages/Finance/BankAccountList';
import BankAccountForm from '../pages/Finance/BankAccountForm';
import BankAccountShow from '../pages/Finance/BankAccountShow';
import Dunning from '../pages/Finance/Dunning';
import DunningTimeline from '../pages/Finance/DunningTimeline';
import DunningReconciliation from '../pages/Finance/DunningReconciliation';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import Profile from '../pages/Account/Profile';
import ChangePassword from '../pages/Account/ChangePassword';

export default function Routing() {
   return (
      <Routes>
         {/* INÍCIO DAS ROTAS DE ROTEIRIZAÇÃO */}
         {/*
            Gate v1.1 (M1+M5): routing:schedule:read dá acesso ao
            snapshot/timeline. Montar rotas (CRUD de subcluster, group-items,
            atribuir técnico) e sobrescrever estado terminal exigem
            routing:subcluster:manage; registrar eventos exige
            routing:schedule:record_event — todos tratados DENTRO da tela
            (a rota só exige leitura).
         */}
         {/*
            Índice master-detail (handoff 0036): lista de roteirizações (uma
            linha por tripla data+período+base). Entrar num card abre o board
            (/routing/management) já escopado na tripla. Mesma permissão de
            leitura do board.
         */}
         <Route
            path="/routing/schedules"
            element={
               <PrivateRoute
                  element={<RoutingScheduleList />}
                  isClosed
                  requiredPermissions="routing:schedule:read"
               />
            }
         />
         <Route
            path="/routing/management"
            element={
               <PrivateRoute
                  element={<RouteManagement />}
                  isClosed
                  requiredPermissions="routing:schedule:read"
               />
            }
         />
         <Route
            path="/routing/items/:itemId"
            element={<PrivateRoute element={<RoutingItemShow />} isClosed />}
         />
         <Route
            path="/routing/items"
            element={<PrivateRoute element={<RoutingItemList />} isClosed />}
         />
         <Route
            path="/routing/items/new"
            element={<PrivateRoute element={<RoutingItemNew />} isClosed />}
         />
         <Route
            path="/routing/reports/productivity"
            element={
               <PrivateRoute
                  element={<ProductivityReport />}
                  isClosed
                  requiredPermissions="routing:report:read"
               />
            }
         />
         {/*
            Catálogo de serviços (M4): leitura gateada por
            routing:schedule_item:read; a escrita (criar/editar/ativar) exige
            routing:service_catalog:manage e é tratada DENTRO da tela.
         */}
         <Route
            path="/routing/service-catalog"
            element={
               <PrivateRoute
                  element={<ServiceCatalog />}
                  isClosed
                  requiredPermissions="routing:schedule_item:read"
               />
            }
         />
         {/* FIM DAS ROTAS DE ROTEIRIZAÇÃO */}

         {/* INÍCIO ROTAS FINANÇAS */}
         <Route
            exact
            path="/billing"
            element={<PrivateRoute element={<BillingCharges />} isClosed />}
         />
         {/* Painel de crediário (handoff 0084). O gate é da ROTA: a página não
             repete a checagem de `finance:dashboard:read` no corpo. */}
         <Route
            exact
            path="/billing/dashboard"
            element={
               <PrivateRoute
                  element={<CreditSalesDashboard />}
                  isClosed
                  requiredPermissions="finance:dashboard:read"
               />
            }
         />
         <Route
            exact
            path="/billing/new"
            element={<PrivateRoute element={<BillingCharge />} isClosed />}
         />
         <Route
            exact
            path="/billing/group/:groupId"
            element={<PrivateRoute element={<BillingGroupShow />} isClosed />}
         />
         <Route
            exact
            path="/billing/:id"
            element={<PrivateRoute element={<BillingCharge />} isClosed />}
         />
         {/* Régua de cobrança (handoff 0090). Gate da ROTA: read; as ações
             internas (update/external/stage:manage) são gateadas na tela. */}
         <Route
            exact
            path="/finance/dunning"
            element={
               <PrivateRoute
                  element={<Dunning />}
                  isClosed
                  requiredPermissions="finance:dunning:read"
               />
            }
         />
         {/* Timeline gerencial da régua (adendo 01) — tela própria, sem os
             filtros operacionais da Central. */}
         <Route
            exact
            path="/finance/dunning/timeline"
            element={
               <PrivateRoute
                  element={<DunningTimeline />}
                  isClosed
                  requiredPermissions="finance:dunning:read"
               />
            }
         />
         {/* Acerto com o escritório de cobrança (handoff 0103). Gate próprio:
             `reconcile` é separada de `read`/`interact` — quem trata os casos,
             inclusive o operador do escritório, não confere o próprio
             trabalho. */}
         <Route
            exact
            path="/finance/dunning/reconciliation"
            element={
               <PrivateRoute
                  element={<DunningReconciliation />}
                  isClosed
                  requiredPermissions="finance:dunning:reconcile"
               />
            }
         />
         {/* FIM ROTAS FINANÇAS */}
         <Route
            exact
            path="/"
            element={<PrivateRoute element={<Main />} isClosed />}
         />
         <Route
            exact
            path="/uishowcasepage"
            element={<PrivateRoute element={<UiShowcasePage />} isClosed />}
         />
         <Route
            exact
            path="/movement-in-by-xml"
            element={<PrivateRoute element={<XmlImportDemo />} isClosed />}
         />
         <Route
            exact
            path="/login"
            element={<PrivateRoute element={<Login />} isClosed={false} />}
         />
         {/*
            Recuperação de acesso (handoff 0098) — rota PÚBLICA, mesmo gate do
            /login (`isClosed={false}`): quem já está logado é mandado para
            /main, porque para trocar a senha com sessão ativa o caminho é
            /account/password, que exige a senha atual.
         */}
         <Route
            exact
            path="/forgot-password"
            element={
               <PrivateRoute element={<ForgotPassword />} isClosed={false} />
            }
         />
         {/*
            Conta do próprio usuário (handoff 0097 §3 e §7.1). Autenticadas e
            SEM `requiredPermissions`: são a conta de quem está logado, não
            administração de terceiros (que fica em /users/:id, sob
            iam:user:update — era iam:user:create até o RBAC por verbo do
            handoff 0110).
         */}
         <Route
            exact
            path="/account/profile"
            element={<PrivateRoute element={<Profile />} isClosed />}
         />
         <Route
            exact
            path="/account/password"
            element={<PrivateRoute element={<ChangePassword />} isClosed />}
         />
         <Route
            exact
            path="/main"
            element={<PrivateRoute element={<Main />} isClosed />}
         />
         <Route path="/" element={<Navigate to="/main" replace />} />
         <Route
            exact
            path="/categories"
            element={<PrivateRoute element={<Categories />} isClosed />}
         />
         <Route
            exact
            path="/newcategory"
            element={<PrivateRoute element={<NewProdCategory />} isClosed />}
         />

         {/* PRODUCT ROUTES */}
         <Route
            exact
            path="/product"
            element={<PrivateRoute element={<ProductEdit />} isClosed />}
         />
         <Route
            exact
            path="/products"
            element={<PrivateRoute element={<Products />} isClosed />}
         />
         <Route
            exact
            path="/product-query"
            element={<PrivateRoute element={<ProdQuery />} isClosed />}
         />
         <Route
            exact
            path="/products/:id"
            element={<PrivateRoute element={<ProductEdit />} isClosed />}
         />
         <Route
            exact
            path="/prodbrands"
            element={<PrivateRoute element={<Brands />} isClosed />}
         />

         {/* MOVEMENT ROUTES */}
         <Route
            exact
            path="/movements"
            element={<PrivateRoute element={<Movements />} isClosed />}
         />
         <Route
            exact
            path="/movements/:id"
            element={<PrivateRoute element={<Movement />} isClosed />}
         />
         <Route
            exact
            path="/movements/:id/edit"
            element={
               <PrivateRoute
                  element={<MovementEdit />}
                  isClosed
                  requiredPermissions="inventory:movement:update"
               />
            }
         />
         {/* Comprovante impresso (handoff de design de 2026-09-13). A
             impressão passou a ser do navegador, então a chave
             `inventory:movement:print` — que antes era exercida pelo endpoint
             de PDF do backend — precisa ser exercida AQUI, na rota, senão
             viraria decoração. O botão do detalhe também é gateado. */}
         <Route
            exact
            path="/movements/:id/receipt"
            element={
               <PrivateRoute
                  element={<MovementReceipt />}
                  isClosed
                  requiredPermissions="inventory:movement:print"
               />
            }
         />
         <Route
            exact
            path="/movement-in"
            element={<PrivateRoute element={<MovementIn />} isClosed />}
         />
         <Route
            exact
            path="/movement-out"
            element={<PrivateRoute element={<MovementOut />} isClosed />}
         />

         {/* TRANSFERÊNCIA DE ESTOQUE ENTRE PDVs (handoff 0099, Fase 1 PUSH) —
             diferente do resto do módulo de estoque, estas rotas declaram
             `requiredPermissions`: leitura e escrita têm chaves distintas
             (adendo §4.3: read chega a 4 papéis, dispatch só a Gestor/Operador),
             e o gate de rota evita que a URL alcance uma tela que só devolveria
             403. */}
         <Route
            exact
            path="/inventory/transfers"
            element={
               <PrivateRoute
                  element={<TransferOrderList />}
                  isClosed
                  requiredPermissions="inventory:transfer:read"
               />
            }
         />
         <Route
            exact
            path="/inventory/transfers/new"
            element={
               <PrivateRoute
                  element={<TransferOrderNew />}
                  isClosed
                  requiredPermissions="inventory:transfer:dispatch"
               />
            }
         />
         <Route
            exact
            path="/inventory/transfers/:id"
            element={
               <PrivateRoute
                  element={<TransferOrderShow />}
                  isClosed
                  requiredPermissions="inventory:transfer:read"
               />
            }
         />
         <Route
            exact
            path="/inventory/transfers/:id/edit"
            element={
               <PrivateRoute
                  element={<TransferOrderEdit />}
                  isClosed
                  requiredPermissions="inventory:transfer:dispatch"
               />
            }
         />
         <Route
            exact
            path="/inventory/shipments"
            element={
               <PrivateRoute
                  element={<TransferShipmentList />}
                  isClosed
                  requiredPermissions="inventory:transfer:read"
               />
            }
         />
         <Route
            exact
            path="/inventory/stock-position"
            element={
               <PrivateRoute
                  element={<StockPosition />}
                  isClosed
                  requiredPermissions="inventory:transfer:read"
               />
            }
         />

         <Route
            exact
            path="/searchstock"
            element={<PrivateRoute element={<SearchStock />} isClosed />}
         />
         {/* ADMIN ROUTES */}
         <Route
            exact
            path="/advancedstocksearch"
            element={
               <PrivateRoute element={<AdvancedProductSearch />} isClosed />
            }
         />
         <Route
            exact
            path="/volumetrycalculator"
            element={
               <PrivateRoute element={<VolumetryCalculator />} isClosed />
            }
         />
         <Route
            exact
            path="/users/new"
            element={
               <PrivateRoute
                  element={<CreateUser />}
                  isClosed
                  requiredPermissions="iam:user:create"
               />
            }
         />

         {/* ROTAS SNAPSHOT */}
         <Route
            exact
            path="/stock/history-by-date"
            element={<PrivateRoute element={<StockHistoryByDate />} isClosed />}
         />
         <Route
            exact
            path="/stock/comparison"
            element={<PrivateRoute element={<StockComparison />} isClosed />}
         />
         <Route
            exact
            path="/stock/evolution"
            element={<PrivateRoute element={<StockEvolution />} isClosed />}
         />
         <Route
            exact
            path="/stock/low-stock-products"
            element={
               <PrivateRoute element={<StockLowStockProducts />} isClosed />
            }
         />
         <Route
            exact
            path="/stock/pdv-snapshot"
            element={<PrivateRoute element={<StockPdvSnapshot />} isClosed />}
         />
         <Route
            exact
            path="/stock/history-by-date"
            element={<PrivateRoute element={<StockHistoryByDate />} isClosed />}
         />
         <Route
            exact
            path="/stock/history-by-date"
            element={<PrivateRoute element={<StockHistoryByDate />} isClosed />}
         />
         {/* FIM ROTAS SNAPSHOT */}

         {/* INÍCIO DAS ROTAS DE USUÁRIOS E RBAC */}
         {/*
            RBAC por verbo (handoff 0110, 2026-09-14): o backend passou a exigir
            `iam:user:read` nas leituras de /users. Sem o gate aqui, a tela
            abriria e só tomaria o 403 do interceptor — que redireciona com
            reload. O gate do PrivateRoute resolve antes da primeira requisição.
            A ficha `/users/:id` é leitura (read); editar/excluir são gateados
            por botão, dentro dela.
         */}
         <Route
            exact
            path="/users/"
            element={
               <PrivateRoute
                  element={<ListUsers />}
                  isClosed
                  requiredPermissions="iam:user:read"
               />
            }
         />
         <Route
            path="/users/:id"
            element={
               <PrivateRoute
                  element={<EditUser />}
                  isClosed
                  requiredPermissions="iam:user:read"
               />
            }
         />
         {/* Gate por verbo desde 2026-09-15 (redesenho do RoleShow) — as
             mesmas chaves que o menu (configuracoesNav) já usa. Antes era só
             isClosed e o 403 chegava via API, com redirect + reload. */}
         <Route
            path="/roles"
            element={
               <PrivateRoute
                  element={<Roles />}
                  isClosed
                  requiredPermissions="iam:role:read"
               />
            }
         />
         <Route
            path="/roles/new"
            element={
               <PrivateRoute
                  element={<RoleShow />}
                  isClosed
                  requiredPermissions="iam:role:create"
               />
            }
         />
         <Route
            path="/roles/:id"
            element={
               <PrivateRoute
                  element={<RoleShow />}
                  isClosed
                  requiredPermissions="iam:role:read"
               />
            }
         />
         <Route
            path="/permissions"
            element={
               <PrivateRoute
                  element={<Permissions />}
                  isClosed
                  requiredPermissions="iam:permission:read"
               />
            }
         />
         <Route
            path="/permissions/:id"
            element={
               <PrivateRoute
                  element={<PermissionShow />}
                  isClosed
                  requiredPermissions="iam:permission:read"
               />
            }
         />
         {/* FIM ROTAS DE USUÁRIOS E RBAC */}

         {/* INÍCIO DAS ROTAS DE TESTES E PROTÓTIPOS */}
         <Route
            path="/service-order-list"
            element={
               <PrivateRoute element={<ServiceOrderList />} isClosed={false} />
            }
         />
         <Route
            path="/service-order-dashboard"
            element={
               <PrivateRoute
                  element={<ServiceOrderDashboard />}
                  isClosed={false}
               />
            }
         />
         <Route
            path="/service-order"
            element={
               <PrivateRoute
                  element={<ServiceOrderShow />}
                     isClosed={false}
               />
            }
         />


         <Route
            path="/experimental-dashboard"
            element={
               <PrivateRoute
                  element={<ExperimentalDashboard />}
                  isClosed={false}
               />
            }
         />
         <Route
            path="/active-crm-prototype"
            element={
               <PrivateRoute
                  element={<ActiveCRMPrototype />}
                  isClosed={false}
               />
            }
         />
         {/* FIM DAS ROTAS DE TESTES E PROTÓTIPOS */}

         {/* INÍCIO DAS ROTAS DE RH - FUNCIONÁRIOS */}
         <Route
            path="/hr/employees/debts-report"
            element={
               <PrivateRoute element={<EmployeeDebtsReport />} isClosed />
            }
         />
         <Route
            path="/hr/employees"
            element={<PrivateRoute element={<EmployeeList />} isClosed />}
         />
         <Route
            path="/hr/employees/new"
            element={<PrivateRoute element={<EmployeeForm />} isClosed />}
         />
         <Route
            path="/hr/employees/:employeeId"
            element={<PrivateRoute element={<EmployeeShow />} isClosed />}
         />
         <Route
            path="/hr/employees/:employeeId/edit"
            element={<PrivateRoute element={<EmployeeForm />} isClosed />}
         />
         {/* FIM DAS ROTAS DE RH - FUNCIONÁRIOS */}

         {/* INÍCIO DAS ROTAS DE RH - RECRUTAMENTO & SELEÇÃO */}
         <Route
            path="/hr/recruitment/pool"
            element={
               <PrivateRoute
                  element={<CandidatePoolList />}
                  isClosed
                  requiredPermissions="hr:candidate:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/candidates/new"
            element={
               <PrivateRoute
                  element={<CandidateForm />}
                  isClosed
                  requiredPermissions="hr:candidate:create"
               />
            }
         />
         <Route
            path="/hr/recruitment/candidates/:id"
            element={
               <PrivateRoute
                  element={<CandidateShow />}
                  isClosed
                  requiredPermissions="hr:candidate:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/candidates/:id/edit"
            element={
               <PrivateRoute
                  element={<CandidateForm />}
                  isClosed
                  requiredPermissions="hr:candidate:update"
               />
            }
         />
         <Route
            path="/hr/recruitment/openings"
            element={
               <PrivateRoute
                  element={<OpeningList />}
                  isClosed
                  requiredPermissions="hr:job_opening:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/openings/new"
            element={
               <PrivateRoute
                  element={<OpeningForm />}
                  isClosed
                  requiredPermissions="hr:job_opening:create"
               />
            }
         />
         <Route
            path="/hr/recruitment/openings/:id"
            element={
               <PrivateRoute
                  element={<OpeningShow />}
                  isClosed
                  requiredPermissions="hr:job_opening:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/openings/:id/edit"
            element={
               <PrivateRoute
                  element={<OpeningForm />}
                  isClosed
                  requiredPermissions="hr:job_opening:update"
               />
            }
         />
         <Route
            path="/hr/recruitment/origins"
            element={
               <PrivateRoute
                  element={<OriginsCatalog />}
                  isClosed
                  requiredPermissions="hr:candidate:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/candidates/:id/onboarding"
            element={
               <PrivateRoute
                  element={<OnboardingShow />}
                  isClosed
                  requiredPermissions="hr:candidate_onboarding:read"
               />
            }
         />
         <Route
            path="/hr/recruitment/position-requirements"
            element={
               <PrivateRoute
                  element={<PositionRequirementsCatalog />}
                  isClosed
                  requiredPermissions="hr:job_position_requirement:read"
               />
            }
         />
         {/* FIM DAS ROTAS DE RH - RECRUTAMENTO & SELEÇÃO */}

         {/* INÍCIO DAS ROTAS DE SERVIÇOS TOMADOS */}
         <Route
            path="/finance/service-aquisition"
            element={
               <PrivateRoute element={<ServiceAquisitionList />} isClosed />
            }
         />
         <Route
            path="/finance/service-aquisition/new"
            element={
               <PrivateRoute element={<ServiceAquisitionForm />} isClosed />
            }
         />
         <Route
            path="/finance/service-aquisition/providers"
            element={
               <PrivateRoute
                  element={<ServiceAquisitionProviderList />}
                  isClosed
               />
            }
         />
         <Route
            path="/finance/service-aquisition/:id"
            element={
               <PrivateRoute element={<ServiceAquisitionShow />} isClosed />
            }
         />
         <Route
            path="/finance/service-aquisition/:id/edit"
            element={
               <PrivateRoute element={<ServiceAquisitionForm />} isClosed />
            }
         />
         {/* FIM DAS ROTAS DE SERVIÇOS TOMADOS */}

         {/* INÍCIO DAS ROTAS FINANCEIRO — CONTAS BANCÁRIAS & CREDENCIAIS */}
         {/*
            Handoff 0079: a chave da ASAAS saiu do .env e virou cadastro
            (bank_accounts + integration_credentials). A rota gateia só a CONTA;
            as credenciais têm permissões próprias (finance:credential:read /
            :manage) e são gateadas DENTRO da ficha — quem enxerga a conta pode
            não enxergar o segredo.
         */}
         <Route
            path="/finance/bank-accounts"
            element={
               <PrivateRoute
                  element={<BankAccountList />}
                  isClosed
                  requiredPermissions="finance:bank_account:read"
               />
            }
         />
         <Route
            path="/finance/bank-accounts/new"
            element={
               <PrivateRoute
                  element={<BankAccountForm />}
                  isClosed
                  requiredPermissions="finance:bank_account:create"
               />
            }
         />
         <Route
            path="/finance/bank-accounts/:id"
            element={
               <PrivateRoute
                  element={<BankAccountShow />}
                  isClosed
                  requiredPermissions="finance:bank_account:read"
               />
            }
         />
         <Route
            path="/finance/bank-accounts/:id/edit"
            element={
               <PrivateRoute
                  element={<BankAccountForm />}
                  isClosed
                  requiredPermissions="finance:bank_account:update"
               />
            }
         />
         {/* FIM DAS ROTAS FINANCEIRO — CONTAS BANCÁRIAS */}

         {/* INÍCIO DAS ROTAS COMERCIAL — CLIENTES */}
         {/*
            Recurso de backend: `customers` (permissões customers:customer:*),
            embora o módulo de menu se chame "Comercial". Endereços reusam a
            permissão de update do cliente e são geridos na tela de detalhe.
         */}
         <Route
            path="/comercial/clientes"
            element={
               <PrivateRoute
                  element={<ClienteList />}
                  isClosed
                  requiredPermissions="customers:customer:read"
               />
            }
         />
         <Route
            path="/comercial/clientes/novo"
            element={
               <PrivateRoute
                  element={<ClienteForm />}
                  isClosed
                  requiredPermissions="customers:customer:create"
               />
            }
         />
         <Route
            path="/comercial/clientes/:id"
            element={
               <PrivateRoute
                  element={<ClienteShow />}
                  isClosed
                  requiredPermissions="customers:customer:read"
               />
            }
         />
         <Route
            path="/comercial/clientes/:id/editar"
            element={
               <PrivateRoute
                  element={<ClienteForm />}
                  isClosed
                  requiredPermissions="customers:customer:update"
               />
            }
         />
         {/* FIM DAS ROTAS COMERCIAL — CLIENTES */}

         <Route path="/403" element={<Page403 />} />
         <Route path="/*" element={<Page404 />} />
      </Routes>
   );
}
